const addResultType = (results) => {
    results.hits = results.hits.map((result) => {
        result.__type = result.__type.replace(/attachment_|post_/ig, '');
        return result;
    });


    return results;
};

export default addResultType;